import { render, staticRenderFns } from "./DestinationDetails.vue?vue&type=template&id=21c50130&scoped=true&"
import script from "./DestinationDetails.vue?vue&type=script&lang=js&"
export * from "./DestinationDetails.vue?vue&type=script&lang=js&"
import style0 from "./DestinationDetails.vue?vue&type=style&index=0&id=21c50130&prod&scoped=true&lang=css&"
import style1 from "./DestinationDetails.vue?vue&type=style&index=1&id=21c50130&prod&lang=css&"
import style2 from "./DestinationDetails.vue?vue&type=style&index=2&id=21c50130&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c50130",
  null
  
)

export default component.exports